import React from 'react';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import SubscriptionPriceInput from '../../signup/SubscriptionPriceInput';
import { usePopupFormManager } from 'features/nekst-widgets';
import { useBillingContext } from './BillingPageContext';
import {
  IntervalType,
  SubscriptionCreationResult,
  SubscriptionCreationResultType, SubscriptionOption,
  SubscriptionPlanId,
  useBillingService
} from 'nekst-api';

export default function UpdateSubscriptionPlanForm(
  props: {
    currentPlanId?: SubscriptionPlanId;
    currentPeriod?: SubscriptionOption;
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const billingService = useBillingService();

  const billingContext = useBillingContext();

  return (
    <FormTemplate
      title="Choose Subscription Plan"
      submitFormFunc={async (data) => {
        return await billingService.updateSubscription(data.subscriptionId, data.subscriptionOption);
      }}
      afterSubmitFunc={async (data: SubscriptionCreationResult) => {
        if (data.type === SubscriptionCreationResultType.CHECKOUT_SESSION_CREATED) {
          window.location.href = data.url!;
        } else {
          billingContext.refresh();
        }
      }}
      initialData={{
        subscriptionId: props.currentPlanId,
        subscriptionOption: props.currentPeriod,
      }}
    >
      <SubscriptionPriceInput />
    </FormTemplate>
  );
}

function intervalTypeToSubscriptionOption(interval?: IntervalType): SubscriptionOption {
  if (interval === IntervalType.YEAR) {
    return SubscriptionOption.ANNUALLY;
  } else {
    return SubscriptionOption.MONTHLY;
  }
}

export function useUpdateSubscriptionPlanForm() {
  const popupFormManager = usePopupFormManager();

  const billingContext = useBillingContext();

  const billingData = billingContext.getData();

  const openForm = () => {
    popupFormManager.openForm(
      <UpdateSubscriptionPlanForm
        currentPlanId={billingData.teamBilling.planId}
        currentPeriod={intervalTypeToSubscriptionOption(billingData.teamBilling.billingInterval)}
      />
    );
  };

  return {
    openForm,
  };
}
